// extracted by mini-css-extract-plugin
export default {"buttonProduct":"Product_buttonProduct__KiznW","productImage":"Product_productImage__XNgoa"};